import api from "../api"; // <-- import your custom axios instance

// Base URL for the City Programs API
const BASE_URL = "/city-programs"; // baseURL is already set in api

// Define the CityProgram type (adjust fields as needed)
export interface CityProgram {
  cityName: string;
  color: string;
  createdAt?: string;
  hidden: boolean;
  icon: string;
  id: string;
  isActive: boolean;
  order: number;
  programs: string[];
  residents: {
    count: number;
    unit: string;
  };
  totalImpact: {
    label: string;
    value: string;
  };
  updatedAt?: string;
  updatedBy?: string;
}

// Define the service
export const CityProgramService = {
  // Create a new city program
  create: async (data: CityProgram): Promise<CityProgram> => {
    // Map frontend model to backend payload
    const payload = {
      active_programs: data.programs,
      city_name: data.cityName,
      hidden: !data.isActive,
      icon: data.icon,
      icon_color: data.color,
      impact_label: data.totalImpact.label,
      impact_value: data.totalImpact.value,
      residents_count: data.residents.count,
      residents_unit: data.residents.unit,
    };
    console.log("Payload being sent:", payload);
    try {
      const response = await api.post(BASE_URL, payload);
      return response.data;
    } catch (error: any) {
      // Log the full error response from backend
      if (error.response) {
        console.error("Backend error response:", error.response.data);
        alert(JSON.stringify(error.response.data)); // Optional: show to user
      } else {
        console.error("Unknown error:", error);
      }
      throw error; // Re-throw the error after logging
    }
  },

  // Delete a city program
  delete: async (id: string): Promise<void> => {
    await api.delete(`${BASE_URL}/${id}`);
  },

  // Fetch all city programs
  getAll: async (): Promise<CityProgram[]> => {
    const response = await api.get(BASE_URL);
    return (response.data.programs || []).map((p: any, idx: number) => ({
      cityName: p.city_name,
      color: p.icon_color,
      createdAt: p.created_at,
      hidden: p.hidden,
      icon: p.icon,
      id: String(p.id),
      isActive: !p.hidden,
      order: idx,
      programs: p.active_programs,
      residents: {
        count: Number(p.residents_count),
        unit: p.residents_unit,
      },
      totalImpact: {
        label: p.impact_label,
        value: p.impact_value,
      },
      updatedAt: p.updated_at,
      updatedBy: p.updated_by,
    }));
  },

  // Hide a city program
  hide: async (id: string): Promise<CityProgram> => {
    const response = await api.post(`${BASE_URL}/${id}/hide`);
    return response.data;
  },

  // Unhide a city program
  unhide: async (id: string): Promise<CityProgram> => {
    const response = await api.post(`${BASE_URL}/${id}/unhide`);
    return response.data;
  },

  // Update an existing city program
  update: async (id: string, data: CityProgram): Promise<CityProgram> => {
    const payload = {
      active_programs: data.programs,
      city_name: data.cityName,
      hidden: !data.isActive,
      icon: data.icon,
      icon_color: data.color,
      impact_label: data.totalImpact.label,
      impact_value: data.totalImpact.value,
      residents_count: data.residents.count,
      residents_unit: data.residents.unit,
    };
    const response = await api.post(`${BASE_URL}/${id}`, payload);
    return response.data;
  },
};
